
    module.exports = function cssToMuiLoader(theme) {
      
      return {
        
        'pageContent': {'display': `flex`,'flexDirection': `column`,'alignItems': `center`,'backgroundColor': `'transparent'`,'paddingTop': `3vh`,'paddingBottom': `3vh`,},'inputSection': {'width': `40%`,'padding': `2%`,'backgroundColor': `#282828`,'boxShadow': `0 1px 2px 0 rgba(0, 0, 0, 0.3)`,'borderRadius': `5px`,},
        
      };
    };
  